import React from 'react';
import ReactSVG from 'react-svg';

import iconFile from 'appSrc/v5/assets/icons/wildlife/favorite-filled.svg';

const FavoriteIcon = ( props ) => {
    const className = `icon-wrapper ${ props.className || '' }`.trim();

    return (
        <ReactSVG src={ iconFile }
        wrapper='div'
        { ...props }
        className={ className } />
    );
};
FavoriteIcon.defaultProps = {
    className: '',
};

export default FavoriteIcon;
